<template>
  <section class="hero hero-header has-sticky-module-header"
    :class="`has-hero-text-${$theme.name} ${`theme-${$theme.name}`}`">
    <div class="hero-body paddingless hanger">
      <nav class="navbar">
        <div class="navbar-brand">
          <!-- Mobile left slot -->
          <div class="navbar-item is-hidden-desktop">
            <div class="field is-grouped">
              <slot name="mobile-left">
                <!-- Default mobile toggle button -->
                <p v-if="showToggle"
                  class="control">
                  <a class="button tooltip is-tooltip-topleft is-primary is-light"
                    :class="buttonCSS"
                    :disabled="!buttonsEnabled"
                    @click="toggleSide"
                    title="Toggle Side Menu"
                    data-tooltip="Toggle Side Menu">
                    <span class="icon">
                      <span class="msr">menu</span>
                    </span>
                  </a>
                </p>
                <p v-if="!licenceExpired && access.isDelete && !serviceError && showCalendar"
                  class="control">
                  <a id="calendar"
                    class="button tooltip is-tooltip-topleft"
                    :class="buttonCSS"
                    @click="calendar"
                    title="Calendar"
                    data-tooltip="Calendar">
                    <span class="icon">
                      <i class="mdi mdi-calendar" />
                    </span>
                  </a>
                </p>
                <p v-if="!licenceExpired && access.isAdd && !serviceError && showNew"
                  class="control">
                  <a id="addnew"
                    class="button tooltip is-tooltip-topleft"
                    :class="buttonCSS"
                    @click="addNew"
                    title="Add New"
                    data-tooltip="Add New">
                    <span class="icon">
                      <span class="msr">add</span>
                    </span>
                  </a>
                </p>
                <p v-if="access.isPrint && !serviceError && showPrint"
                  class="control">
                  <a id="print"
                    class="button tooltip is-tooltip-topleft"
                    :class="buttonCSS"
                    @click="print"
                    title="Print"
                    data-tooltip="Print">
                    <span class="icon">
                      <span class="msr">print</span>
                    </span>
                  </a>
                </p>
                <p v-if="!licenceExpired && access.isDelete && !serviceError && showDelete"
                  class="control">
                  <a id="delete"
                    class="button tooltip is-tooltip-topleft"
                    :class="buttonCSS"
                    @click="trash"
                    title="Delete"
                    data-tooltip="Delete">
                    <span class="icon">
                      <span class="msr">delete</span>
                    </span>
                  </a>
                </p>
                <p v-if="!licenceExpired && access.isEdit && !serviceError && showSave && !(showAutoSave && entity && !entity.isNew)"
                  class="control">
                  <a id="save"
                    class="button tooltip is-tooltip-topleft"
                    :class="buttonCSS"
                    @click="save"
                    title="Save"
                    data-tooltip="Save">
                    <span class="icon">
                      <span class="msr">save</span>
                    </span>
                  </a>
                </p>
                <p v-if="showCancel"
                  class="control">
                  <a id="cancel"
                    class="button tooltip is-tooltip-topleft"
                    :class="buttonCSS"
                    @click="cancel"
                    title="Go Back"
                    data-tooltip="Go Back">
                    <span class="icon">
                      <span class="msr">arrow_back</span>
                    </span>
                  </a>
                </p>
                <p v-if="showLock"
                  class="control">
                  <a id="lock"
                    class="button tooltip is-tooltip-topleft"
                    :class="buttonCSS"
                    :disabled="isSaving || licenceExpired"
                    @click="!isSaving && !licenceExpired && toggleReadOnly()"
                    :data-tooltip="licenceExpired ? 'Disabled, as your licence has expired' : 'Lock Manage'">
                    <span class="icon">
                      <span class="msr">{{ entity.readOnly ? 'lock' : 'lock_open' }}</span>
                    </span>
                  </a>
                </p>
              </slot>
            </div>
          </div>

          <!-- Mobile burger menu -->
          <div class="navbar-burger burger"
            data-target="action-button-menu">
            <span />
            <span />
            <span />
          </div>

        </div>

        <!-- Desktop left slot -->
        <div id="detail-nav-menu"
          class="navbar-start is-hidden-touch">
          <div v-if="showToggle"
            class="navbar-item">
            <h1 class="title">
              <a class="button is-primary is-outlined"
                :class="buttonCSS"
                :disabled="!buttonsEnabled"
                @click="toggleSide">
                <span class="icon">
                  <span class="msr msr-24px">menu</span>
                </span>
              </a>
            </h1>
          </div>
          <div class="navbar-item">
            <slot name="desktop-left" />
          </div>
        </div>

        <!-- Center content slot -->
        <div class="navbar-item has-text-centered"
          v-if="$slots['center']">
          <slot name="center" />
        </div>

        <!-- Desktop right buttons -->
        <div class="navbar-end is-hidden-touch">
          <div class="navbar-item">
            <div class="field is-grouped">
              <slot name="desktop-right">
                <!-- Primary action buttons -->
                <p v-if="!licenceExpired && access.isAdd && !serviceError && showCalendar"
                  class="control">
                  <a id="calendar"
                    class="button is-primary"
                    :class="buttonCSS"
                    @click="calendar">
                    <span class="icon">
                      <i class="mdi mdi-calendar mdi-18px" />
                    </span>
                    <span>Calendar</span>
                  </a>
                </p>

                <p v-if="!licenceExpired && access.isAdd && !serviceError && showNew"
                  class="control">
                  <a id="addnew"
                    class="button is-success"
                    :class="buttonCSS"
                    @click="addNew">
                    <span class="icon">
                      <span class="msr msr-18px">add</span>
                    </span>
                    <span>New</span>
                  </a>
                </p>

                <p v-if="access.isPrint && !serviceError && showPrint && false"
                  class="control">
                  <a id="preview"
                    class="button is-primary"
                    :class="buttonCSS"
                    @click="print">
                    <span class="icon">
                      <span class="msr msr-18px">print</span>
                    </span>
                    <span>Preview</span>
                  </a>
                </p>
                <p v-if="!licenceExpired && access.isDelete && !serviceError && showDelete && false"
                  class="control">
                  <a id="delete"
                    class="button is-danger"
                    :class="buttonCSS"
                    @click="trash">
                    <span class="icon">
                      <span class="msr msr-18px">delete</span>
                    </span>
                    <span>Delete</span>
                  </a>
                </p>
                <p v-if="!licenceExpired && access.isEdit && !serviceError && showConvert"
                  class="control">
                  <a id="convert"
                    class="button is-primary"
                    :class="buttonCSS"
                    @click="convert">
                    <span class="icon">
                      <i class="mdi mdi-swap-horizontal mdi-18px" />
                    </span>
                    <span>Convert</span>
                  </a>
                </p>

                <!-- Autosave status when enabled (hidden for new quotes) -->
                <div v-if="!licenceExpired && access.isEdit && !serviceError && showSave && autoSaveEnabled && entity && !entity.isNew"
                  class="control is-flex is-flex-direction-row is-align-items-center mr-2"
                  v-tippy="{ content: autoSaveStatus, enabled: true }">
                  <span class="material-symbols-rounded mr-2"
                    :class="{
                      'loading': (isSaving) && !hasAutoSaveFailed,
                      'has-text-grey': (isSaving || unsavedChanges) && !hasAutoSaveFailed,
                      'has-text-danger': hasAutoSaveFailed,
                      'has-text-grey-light': !isSaving && !hasAutoSaveFailed && !unsavedChanges,
                    }"
                  >
                    {{ isSaving ? 'sync' : hasAutoSaveFailed ? 'cloud_off' : 'cloud_done' }}
                  </span>
                  <!-- <span class="is-size-7 is-italic has-text-grey has-text-weight-semibold">
                    {{ (isSaving || unsavedChanges) ? 'Saving...' : hasAutoSaveFailed ? 'Failed' : 'Saved' }}
                  </span> -->
                </div>

                <!-- Save button / Autosave status indicator -->
                <p v-if="!licenceExpired && access.isEdit && !serviceError && showSave && autoSaveLocked"
                  class="control">
                  <a id="save"
                    class="button is-success"
                    :class="[buttonCSS]"
                    @click="save"
                    v-tippy="{ content: hasAutoSaveFailed ? 'Autosave failed - Click to save manually' : '', enabled: hasAutoSaveFailed }">
                    <span class="icon">
                      <span class="msr msr-18px">{{ hasAutoSaveFailed ? 'cloud_off' : 'save' }}</span>
                    </span>
                    <span>{{ hasAutoSaveFailed ? 'Save Manually' : (entity && entity.isNew ? 'Create' : 'Save') }}</span>
                  </a>
                </p>

                <p v-if="showCancel"
                  class="control">
                  <a id="cancel"
                    class="button is-primary"
                    :class="buttonCSS"
                    @click="cancel">
                    <span class="icon">
                      <span class="msr msr-18px">arrow_back</span>
                    </span>
                    <span>Back</span>
                  </a>
                </p>
              </slot>

              <!-- More actions dropdown -->
              <div v-show="hasMoreActions"
                name="headerMoreButtons"
                class="button px-2"
                @mouseenter="handleMoreButtonHover">
                <span class="icon">
                  <span class="msr msr-36px">more_vert</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </nav>
    </div>

    <!-- Additional content slot (for tippy, modals, etc.) -->
    <slot name="additional-content">
      <!-- More actions dropdown menu -->
      <tippy v-if="hasMoreActions"
        ref="tippyHeaderButtons"
        to="headerMoreButtons"
        trigger="click"
        arrow
        :theme="`${$theme.name}`"
        :interactive="true"
        :max-width="500">
        <div class="menu more-menu">
          <ul class="menu-list">
            <li v-if="!licenceExpired && !serviceError && showCreditorStatement">
              <a class="is-flex is-align-items-center"
                id="viewCreditorStatement"
                @click="viewCreditorStatement">
                <span class="icon pr-3">
                  <span class="msr msr-20px">request_page</span>
                </span>
                <span>View Creditor Statement</span>
              </a>
            </li>

            <li v-if="!licenceExpired && !serviceError && showDebtorStatement">
              <a class="is-flex is-align-items-center"
                id="viewDebtorStatement"
                @click="viewDebtorStatement">
                <span class="icon pr-3">
                  <span class="msr msr-20px">request_page</span>
                </span>
                <span>View Debtor Statement</span>
              </a>
            </li>

            <li v-if="!licenceExpired && !serviceError && showAdvancePaymentEntry">
              <a class="is-flex is-align-items-center"
                id="viewAdvancePaymentEntry"
                @click="viewAdvancePaymentEntry">
                <span class="icon pr-3">
                  <span class="msr msr-20px">request_page</span>
                </span>
                <span>Advance Payment Entry</span>
              </a>
            </li>

            <li v-if="!licenceExpired && !serviceError && showAdvanceReceiptEntry">
              <a class="is-flex is-align-items-center"
                id="viewAdvanceReceiptEntry"
                @click="viewAdvanceReceiptEntry">
                <span class="icon pr-3">
                  <span class="msr msr-20px">request_page</span>
                </span>
                <span>Advance Receipt Entry</span>
              </a>
            </li>

            <li v-if="!licenceExpired && !serviceError && showFactorInvoice">
              <a class="is-flex is-align-items-center"
                id="factorInvoice"
                @click="factorInvoice">
                <span class="icon pr-3">
                  <span class="msr msr-20px">receipt_long</span>
                </span>
                <span>Factor Invoices</span>
              </a>
            </li>

            <li v-if="!licenceExpired && !serviceError && showFactorSelectedInvoice">
              <a class="is-flex is-align-items-center"
                id="factorSelectedInvoice"
                @click="factorSelectedInvoice">
                <span class="icon pr-3">
                  <span class="msr msr-20px">receipt_long</span>
                </span>
                <span>Factor Selected Invoices</span>
              </a>
            </li>

            <li v-if="!licenceExpired && !serviceError && showBankUnDepositedFunds">
              <a class="is-flex is-align-items-center"
                id="viewBankUnDepositedFunds"
                @click="viewBankUnDepositedFunds">
                <span class="icon pr-3">
                  <span class="msr msr-20px">account_balance</span>
                </span>
                <span>Bank Un-Deposited Funds</span>
              </a>
            </li>

            <li v-if="access.isPrint && !serviceError && showPrint">
              <a id="preview"
                class="is-flex is-align-items-center"
                @click="print">
                <span class="icon pr-3">
                  <span class="msr msr-20px">print</span>
                </span>
                <span>Preview</span>
              </a>
            </li>
            <li v-if="!licenceExpired && !serviceError && showLock">
              <a class="is-flex is-align-items-center"
                :class="{ 'has-text-grey-light': isSaving }"
                id="lock"
                @click="!isSaving && toggleReadOnly()">
                <span class="icon pr-3">
                  <span class="msr msr-20px">{{ entity.readOnly ? 'lock' : 'lock_open' }}</span>
                </span>
                <span>{{ entity.readOnly ? 'Unlock' : 'Lock' }}</span>
              </a>
            </li>

            <li v-if="!serviceError && showPricePartsMsg">
              <a id="priceparts"
                class="is-flex is-align-items-center"
                @click="viewPricePartsMsg">
                <span class="icon pr-3">
                  <span class="msr msr-20px">chat</span>
                </span>
                <span>View Price Parts Messages</span>
              </a>
            </li>

            <li v-if="!licenceExpired && access.isEdit && !serviceError && showAdditionalQuoteButtons && showAdditionalQuote">
              <a class="is-flex is-align-items-center pl-1"
                id="new_additional_quote"
                @click="newAdditionalQuote"
              >
                <span class="msr msr-24px mr-1"
                  style="font-size: 20px;">
                  add
                </span>
                <span>New Additional Quote</span>
              </a>
            </li>

            <li v-if="!licenceExpired && access.isEdit && !serviceError && showAdditionalQuoteButtons">
              <a class="is-flex is-align-items-center pl-1"
                id="copy_quote"
                @click="copyQuote"
              >
                <span class="msr msr-24px mr-1"
                  style="font-size: 20px;"
                >
                  content_copy
                </span>
                <span>Copy Quote</span>
              </a>
            </li>

            <li v-if="!licenceExpired && access.isEdit && !serviceError && showAdditionalQuoteButtons">
              <a class="is-flex is-align-items-center pl-1"
                id="export_quote"
                @click="exportQuote"
              >
                <span class="msr msr-24px mr-1"
                  style="font-size: 20px;"
                >
                  file_export
                </span>
                <span>Export Quote</span>
              </a>
            </li>

            <li v-if="!licenceExpired && !serviceError && showQuoteTemplate">
              <div v-if="!quoteTemplateDisabled">
                <a id="quoteTemplate"
                  class="is-flex is-align-items-center"
                  @click="saveTemplateFromQuote">
                  <span class="icon pr-3">
                    <span class="msr msr-20px">add</span>
                  </span>
                  <span>Save as Template</span>
                </a>
              </div>
              <div v-else>
                <button class="is-flex is-align-items-center button is-white
            is-fullwidth pl-0 is-justify-content-flex-start"
                  id="quoteTemplate"
                  :disabled="quoteTemplateDisabled">
                  <span class="icon ml-0">
                    <span class="msr msr-20px">print</span>
                  </span>
                  <span>Save as Template</span>
                </button>
              </div>
            </li>

            <div v-if="!licenceExpired && access.isDelete && !serviceError && showDelete && showPrint"
              class="is-divider" />
            <li v-if="!licenceExpired && access.isDelete && !serviceError && showDelete">
              <a class="has-text-danger is-flex is-align-items-center"
                id="delete"
                @click="trash">
                <span class="icon pr-3">
                  <span class="msr msr-20px">delete</span>
                </span>
                <span>Delete</span>
              </a>
            </li>

            <!-- Custom slot for additional menu items -->
            <slot name="more-menu-items">
              <!-- <li v-if="showCustomOption">
                <a class="is-flex is-align-items-center"
                  @click="onHeaderButtonClicked('custom')">
                  <span class="icon pr-3">
                    <span class="msr msr-20px">settings</span>
                  </span>
                  <span>Custom Action</span>
                </a>
              </li> -->
            </slot>

            <!-- Manual save fallback while autosave is on and working.
                 Only shown for companies opted into keeping the Save button (Experiment 2);
                 kept at the very bottom of the menu, below all other buttons, per FQ-3009. -->
            <li v-if="!licenceExpired && access.isEdit && !serviceError && showSave && autoSaveEnabled && manualSaveEnabled && entity && !entity.isNew && !hasAutoSaveFailed">
              <a id="manualSave"
                class="is-flex is-align-items-center"
                @click="manualSave">
                <span class="icon pr-3">
                  <span class="msr msr-20px">save</span>
                </span>
                <span>Save</span>
              </a>
            </li>
          </ul>
        </div>
      </tippy>
    </slot>
  </section>
</template>

<script>
import HttpStatus from '@/components/http-status'
import EventBus from '@/components/EventBus'
import { mapGetters } from 'vuex'
import { EventHubTypes, AppHeaderButtonTypes } from '@/enums'

export default {
  name: 'ModuleDetailHeader',
  props: {
    entity: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: ''
    },
    showNew: {
      type: Boolean,
      default: true
    },
    showCalendar: {
      type: Boolean,
      default: false
    },
    showPrint: {
      type: Boolean,
      default: true
    },
    showDelete: {
      type: Boolean,
      default: true
    },
    showSave: {
      type: Boolean,
      default: true
    },
    showCancel: {
      type: Boolean,
      default: true
    },
    showToggle: {
      type: Boolean,
      default: false
    },
    showLock: {
      type: Boolean,
      default: false
    },
    value: null,
    showPricePartsMsg: {
      type: Boolean,
      default: false
    },
    showQuoteTemplate: {
      type: Boolean,
      default: false
    },
    quoteTemplateDisabled: {
      type: Boolean,
      default: true
    },
    applyRepairerTemplate: {
      type: Boolean,
      default: false
    },
    showConvert: {
      type: Boolean,
      default: false
    },
    quoteCancelled: {
      type: Boolean,
      default: false
    },
    showAutoSave: {
      type: Boolean,
      default: false
    },
    autoSaveLocked: {
      type: Boolean,
      default: false
    },
    autoSaveEnabled: {
      type: Boolean,
      default: true
    },
    manualSaveEnabled: {
      type: Boolean,
      default: false
    },
    isAutoSaveSaving: {
      type: Boolean,
      default: false
    },
    autoSaveStatus: {
      type: String,
      default: ''
    },
    isSaving: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    unsavedChanges: {
      type: Boolean,
      default: false
    },
    hasAutoSaveFailed: {
      type: Boolean,
      default: false
    },
    showAdditionalQuoteButtons:{
      type: Boolean,
      default: false
    },
    showAdditionalQuote: {
      type: Boolean,
      default: false
    },
    showCreditorStatement: {
      type: Boolean,
      default: false
    },
    showDebtorStatement: {
      type: Boolean,
      default: false
    },
    showAdvancePaymentEntry: {
      type: Boolean,
      default: false
    },
    showAdvanceReceiptEntry: {
      type: Boolean,
      default: false
    },
    showFactorInvoice: {
      type: Boolean,
      default: false
    },
    showFactorSelectedInvoice: {
      type: Boolean,
      default: false
    },
    showBankUnDepositedFunds: {
      type: Boolean,
      default: false
    },
    buttonsEnabled: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      serviceError: false,
      access: {},
      showSideMenu: true
    }
  },
  computed: {
    buttonCSS: function () {
      return 'has-text-' + this.$theme.name
    },
    hasMoreActions() {
      return this.showPrint || this.showDelete || this.showLock || this.showQuoteTemplate || this.showMessages ||
        (this.autoSaveEnabled && this.entity && !this.entity.isNew && !this.hasAutoSaveFailed)
    },
    ...mapGetters(['licenceExpired'])
  },
  watch: {
    $route(to, from) {
      this.setAccess()
    }
  },
  created() {
    EventBus.$on('serviceError', (data) => {
      this.handleBusEvent(data)
    })
    this.$eventHub.$on(EventHubTypes.AutoHideSideMenu, (data) => {
      this.handleSideMenuEvent(data)
    })
  },
  mounted() {
    this.setAccess()
  },
  methods: {
    addNew() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.AddNew)
    },
    print() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.Print)
    },
    trash() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.Delete)
    },
    save() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.Save)
    },
    manualSave() {
      if (!this.buttonsEnabled) return
      this.$emit('manual-save-request')
    },
    toggleAutoSave() {
      this.$emit('toggle-auto-save')
    },
    cancel() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.Cancel)
    },
    toggleSide() {
      this.showSideMenu = !this.showSideMenu
      this.$eventHub.$emit(EventHubTypes.ToggleSideMenu, this.showSideMenu)
    },
    handleBusEvent(data) {
      this.serviceError = data === HttpStatus.NOT_FOUND
    },
    handleSideMenuEvent(data) {
      this.showSideMenu = !data
    },
    toggleReadOnly() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.Lock)
    },
    viewPricePartsMsg() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.PriceParts)
    },
    handleMoreButtonHover() {
      this.$emit('more-button-hover')
      this.handleBurgerButton()
    },
    handleBurgerButton() {
      if (this.showQuoteTemplate) {
        this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.PreApplyQuoteTemplateCheck)
      }
    },
    applyQuoteTemplate() {
      if (!this.quoteTemplateDisabled) {
        this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.ApplyQuoteTemplate)
      }
    },
    calendar() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.Calendar)
    },
    convert() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.Convert)
    },
    setAccess() {
      if (this.$route && this.$route.meta) {
        if (this.$route.meta.access) this.access = this.$route.meta.access
        else this.access = {}
      }
    },
    saveTemplateFromQuote() {
      this.$eventHub.$emit(EventHubTypes.saveTemplateFromQuote)
    },
    newAdditionalQuote() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.NewAdditionalQuote)
    },
    copyQuote() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.CopyQuote)
    },
    exportQuote() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.ExportQuote)
    },
    viewCreditorStatement() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.ViewCreditorStatement)
    },
    viewDebtorStatement() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.ViewDebtorStatement)
    },
    viewAdvancePaymentEntry() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.ViewAdvancePaymentEntry)
    },
    viewAdvanceReceiptEntry() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.ViewAdvanceReceiptEntry)
    },
    factorInvoice() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.FactorInvoice)
    },
    factorSelectedInvoice() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.FactorSelectedInvoice)
    },
    viewBankUnDepositedFunds() {
      this.$emit(EventHubTypes.AppDetailHeaderButtonClicked, AppHeaderButtonTypes.ViewBankUnDepositedFunds)
    }
  }
}
</script>

<style lang="scss" scoped>

// .hero-header {
//   background-color: var(--bulma-body-background-color);
//   // background-color: #f0f2f4;
//   // border-bottom: solid 1px #dee2e6;
// }
.navbar {
  height: 52px;
}
// .menu-list a:hover {
//   background-color: hsl(0, 0%, 90%) !important;
// }
.menu.more-menu {
  min-width: 15rem !important;
}
.is-divider {
  margin: 0.5rem 0;
}
.hanger {
  margin: 0.75rem 0.75rem 0 0.75rem;
  background-color: var(--background-color);
  border-radius: 4px !important;
  padding: 0.5rem;
}
// .hanger > .navbar {
//   border-bottom: solid 1px #dee2e6;
// }

.loading {
  animation: circle-9-loading 1.5s infinite linear;
  transform: scale(0.5);
}

@keyframes circle-9-loading {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}

</style>